import React, { useState } from "react";
import { PageHeader, Button, Space } from "antd";
import {
	LockOutlined,
	SaveOutlined,
	UnlockOutlined,
	ExpandAltOutlined,
	ShrinkOutlined,
} from "@ant-design/icons";
import StatusTag from "components/StatusTag";
import { selectForm } from "reducers";
import dayjs from "dayjs";
import { useSelector, useDispatch } from "react-redux";
import { lockToggled, selectQnaIsLocked } from "reducers/formSlice";
import Comment from "../approval/Comment";
import { selectIsAppAdmin, selectUser } from "reducers/securitySlice";
import { postWorkflowHistoryThunk } from "reducers/workflowHistorySlice";

const FormHeader = ({
	save,
	setOverrideApprovalMode,
	isApprovalMode,
	isDraft,
}) => {
	const [showComment, setShowComment] = useState(false);
	const dispatch = useDispatch();
	const form = useSelector(selectForm);
	const isLocked = useSelector(selectQnaIsLocked);
	const { createByUser, status, createOn } = form;
	const { id, userId, fullName } = useSelector(selectUser);
	const isAppAdmin = useSelector(selectIsAppAdmin);
	const canLock = isAppAdmin || userId === createByUser?.userId;

	return (
		<PageHeader
			title={
				<span style={{ color: "white" }}>{`${
					createOn ? "" : "New "
				}Capital Expenditure Request Form`}</span>
			}
			subTitle={
				<span style={{ color: "white" }}>
					{createOn &&
						`Raised by ${
							createByUser?.firstName +
							" " +
							createByUser?.lastName
						} on ${dayjs(createOn).format("DD/MM/YYYY h:mm a")}`}
				</span>
			}
			className="site-page-header"
			extra={[
				<Button
					hidden={!isApprovalMode}
					onClick={() => setOverrideApprovalMode(true)}
					key="1"
				>
					<ExpandAltOutlined />
					Show Full Form Detail
				</Button>,
				<Button
					hidden={isApprovalMode || isDraft}
					onClick={() => setOverrideApprovalMode(false)}
					key="1.5"
				>
					<ShrinkOutlined />
					Hide Full Form Detail
				</Button>,
				<Button
					hidden={isLocked || status === "Draft" || !canLock}
					key="2"
					onClick={() => dispatch(lockToggled())}
				>
					<LockOutlined />
					Lock from Editing
				</Button>,
				<Button
					key="4"
					hidden={!isLocked || status === "Draft" || !canLock}
					onClick={() => setShowComment(true)}
				>
					<UnlockOutlined /> Unlock For Editing
				</Button>,
				<Button
					disabled={isLocked}
					type="primary"
					key="3"
					onClick={() => {
						if (!isLocked && status !== "Draft") {
							dispatch(lockToggled());
						}
						save({ isSilentSave: false });
					}}
				>
					<SaveOutlined />{" "}
					{!isLocked && status !== "Draft" ? "Save and Lock" : "Save"}
				</Button>,
			]}
		>
			<Comment
				open={showComment}
				type={"Unlock"}
				onOk={({ comments }) => {
					dispatch(
						postWorkflowHistoryThunk({
							action: "Unlock",
							description:
								"Form unlocked for editing by " + fullName,
							category: "",
							comment: comments,
							userId: id,
						})
					);
					dispatch(lockToggled());
					//switch automatically to editable form
					setOverrideApprovalMode(true);
					setShowComment(false);
				}}
				initialValues={{
					userId: userId,
				}}
				onCancel={() => setShowComment(false)}
			/>
			<Space>
				Form Status
				<StatusTag status={status || "Draft"} />
				{isLocked && <StatusTag status="Locked" />}
			</Space>
		</PageHeader>
	);
};

export default FormHeader;
